import requestReducerFactory from './requestReducerFactory';
import { RequestRules, RulesError, RulesLoaded } from '../actions/jiraRules';

export default requestReducerFactory(RequestRules, RulesLoaded, RulesError);
